export default "__VITE_ASSET__Db7xGHmx__"